
import './gsk-react-app.css'

import React, { ReactNode} from 'react'
import { Provider, useSelector } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { IAuthenticationProps } from '@gsk-tech/gsk-react-framework/dist/components/gsk-login-form/gsk-login-form'
import { GSKSSO } from '../gsk-sso/gsk-sso';
import { GSKMain, IUIProps } from '../gsk-main-component/gsk-main'
import { IReduxAction, store } from '@gsk-tech/gsk-react-framework'
import { GSKLoginForm } from '../gsk-login-form/gsk-login-form'
import { AuthProvider } from '../../../store/sso/src/authProvider'

export interface IGSKAppProps {
	ui: IUIProps,
	authentication?: IAuthenticationProps,
	singleSignOn: ISingleSingOnProps
}
export interface IAuthenticationResponse {
	isAuthenticated: boolean
	user: {
		name: string,
		token: string
	}
}
export interface ISingleSingOnProps {
	isSingleSignOnEnabled: boolean,
	authProviderProps: {
		homePageUrl?: string;
		loadingScreen: JSX.Element;
		children: JSX.Element;
		authUrl: string;
		redirectUrl: string;
		clientId: string;
		refreshTokensEnabled?: boolean;
		scope?: string;
		loggedOutUrl?: string,
	}
	securityGroup?: string[]
	action: IReduxAction
	actionSuccess?: string
	selector?: any
}

export function GSKAppWrapper({ children }: { children: ReactNode }) {
	return (
		<Provider store={store}>
			<BrowserRouter>
				{children}
			</BrowserRouter>
		</Provider>
	)
}

export const GSKReactApp: React.FC<IGSKAppProps> = (props: IGSKAppProps) => {

	const response: IAuthenticationResponse | undefined = useSelector((props : IGSKAppProps) => {
		if (props.authentication) {
			return props.authentication.selector;
		}
		return undefined;
	});

	if (props.singleSignOn && props.singleSignOn.isSingleSignOnEnabled) {
		const authProviderProps = props.singleSignOn.authProviderProps

		return (
			<AuthProvider
				homePageUrl={authProviderProps.homePageUrl}
				loggedOutUrl={authProviderProps.loggedOutUrl ? authProviderProps.loggedOutUrl : ''}
				authUrl={authProviderProps.authUrl}
				clientId={authProviderProps.clientId}
				redirectUrl={authProviderProps.redirectUrl}
				loadingScreen={<div className="loadingScreen">
                <img src="logo192.png" alt="GSK Logo" />
                <br/>
                <br/>
                <span>Loading...</span>
            </div>}
				refreshTokensEnabled={authProviderProps.refreshTokensEnabled} >
				<GSKSSO {...{ singleSignOn: props.singleSignOn, ui: props.ui }} />
			</AuthProvider>
		)
	}
	else if (props.authentication === undefined || response?.isAuthenticated) {

		return (
			<div>
				<GSKMain {...{ ui: props.ui }} />
			</div>
		)

	} else {

		return (
			<div>
				<GSKLoginForm {...props.authentication}></GSKLoginForm>
			</div>
		)
	}
}
